import { IFlatAddOnDescriptor } from "../types";

/** Billed, with no UI of its own. */
const pythonExecution = {
  productType: "python-execution",
  kind: "flat",
  title: "Python execution",
  getBillingRowItem: () => ({}),
} satisfies IFlatAddOnDescriptor;

export default pythonExecution;
